import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { EULA_STATUS } from '~/features/devices/constants/eulaStatus';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';

interface EulaStatusProps {
    eulaStatus?: string | null;
}

const EULA_STATUS_CONFIG = {
    [EULA_STATUS.ACCEPTED]: {
        label: 'intl-msg:eulaStatus.accepted',
        className: 'label-success',
    },
    [EULA_STATUS.DECLINED]: {
        label: 'intl-msg:eulaStatus.declined',
        className: 'label-warning',
    },
    [EULA_STATUS.NOT_APPLICABLE]: {
        label: 'intl-msg:eulaStatus.notApplicable',
        className: 'label-info',
    },
    'UNKNOWN': {
        label: 'intl-msg:eulaStatus.unknown',
        className: 'label-default',
    },
};

const EulaStatus: React.FC<EulaStatusProps> = ({ eulaStatus }) => {
    if (eulaStatus === undefined) {
        return <FieldOrNoData field={null} />;
    }

    const statusToUse = eulaStatus === null ? 'UNKNOWN' : eulaStatus;

    const config = EULA_STATUS_CONFIG[statusToUse];

    if (!config) {
        return <span>{statusToUse}</span>;
    }

    return (
        <span className={classNames('label label-condensed', config.className)}>
            <FormattedMessage id={config.label} />
        </span>
    );
};

export default EulaStatus;
